import JobAgreement from 'models/JobAgreement';
import JobCategory from 'models/JobCategory';
import JobExperience from 'models/JobExperience';
import JobLanguage from 'models/JobLanguage';
import JobMode from 'models/JobMode';
import JobTime from 'models/JobTime';

import Component from './component';

export interface Props {
    jobCategories?: JobCategory[];
    jobAgreements?: JobAgreement[];
    jobModes?: JobMode[];
    jobExperiences?: JobExperience[];
    jobLanguages?: JobLanguage[];
    jobTimes?: JobTime[];

    searchParams: any;
    onChangeSearchParam: (key: string, value: any, clear?: boolean) => void;
    onClearFilters: (keys: string[]) => void;
    onClearAll: () => void;
}

Component.defaultProps = {
    jobCategories: [],
    jobAgreements: [],
    jobModes: [],
    jobExperiences: [],
    jobLanguages: [],
    jobTimes: [],
};

export default Component;
